export const districtTypes = [
  { id: 502, type: 'тер', typeFull: 'Территория' },
  { id: 503, type: 'р-н', typeFull: 'Район' },
];
export const settlementTypes = [
  { id: 601, type: 'аал', typeFull: 'Аал' },
  { id: 602, type: 'аул', typeFull: 'Аул' },
  { id: 603, type: 'волость', typeFull: 'Волость' },
  { id: 604, type: 'высел', typeFull: 'Выселки(ок)' },
  { id: 605, type: 'г', typeFull: 'Город' },
  { id: 606, type: 'д', typeFull: 'Деревня' },
  { id: 607, type: 'дп', typeFull: 'Дачный поселок' },
  { id: 613, type: 'ж/д_ст', typeFull: 'Железнодорожная станция' },
  { id: 615, type: 'казарма', typeFull: 'Казарма' },
  { id: 616, type: 'кп', typeFull: 'Курортный поселок' },
  { id: 617, type: 'м', typeFull: 'Местечко' },
  { id: 618, type: 'мкр', typeFull: 'Микрорайон' },
  { id: 619, type: 'нп', typeFull: 'Населенный пункт' },
  { id: 620, type: 'остров', typeFull: 'Остров' },
  { id: 621, type: 'п', typeFull: 'Поселок' },
  { id: 622, type: 'пл.р-н', typeFull: 'Планировочный район' },
  { id: 623, type: 'п/ст', typeFull: 'Поселок и(при) станция(и)' },
  { id: 624, type: 'пгт', typeFull: 'Поселок городского типа' },
  { id: 625, type: 'починок', typeFull: 'Починок' },
  { id: 626, type: 'п/о', typeFull: 'Почтовое отделение' },
  { id: 627, type: 'промзона', typeFull: 'Промышленная зона' },
  { id: 628, type: 'рзд', typeFull: 'Разъезд' },
  { id: 629, type: 'рп', typeFull: 'Рабочий поселок' },
  { id: 630, type: 'с', typeFull: 'Село' },
  { id: 631, type: 'сл', typeFull: 'Слобода' },
  { id: 632, type: 'ст', typeFull: 'Станция' },
  { id: 633, type: 'ст-ца', typeFull: 'Станица' },
  { id: 634, type: 'у', typeFull: 'Улус' },
  { id: 635, type: 'х', typeFull: 'Хутор' },
  { id: 636, type: 'г-к', typeFull: 'Городок' },
  { id: 637, type: 'тер', typeFull: 'Территория' },
  { id: 639, type: 'кв-л', typeFull: 'Квартал' },
  { id: 640, type: 'арбан', typeFull: 'Арбан' },
  { id: 641, type: 'снт', typeFull: 'Садовое неком-е товарищество' },
  { id: 645, type: 'автодорога', typeFull: 'Автодорога' },
  { id: 646, type: 'жилрайон', typeFull: 'Жилой район' },
  { id: 647, type: 'жилзона', typeFull: 'Жилая зона' },
  { id: 648, type: 'массив', typeFull: 'Массив' },
  { id: 649, type: 'гп', typeFull: 'Городской поселок' },
  { id: 651, type: 'пгт.', typeFull: 'Поселок городского типа' },
  { id: 654, type: 'киш.', typeFull: 'Кишлак' },
  { id: 655, type: 'п. ж/д ст.', typeFull: 'Поселок при железнодорожной станции' },
  { id: 658, type: 'ж/д к-ма', typeFull: 'Железнодорожная казарма' },
  { id: 663, type: 'нп.', typeFull: 'Населенный пункт' },
  { id: 664, type: 'дп.', typeFull: 'Дачный поселок' },
  { id: 665, type: 'сп.', typeFull: 'Сельский поселок' },
  { id: 666, type: 'пос.рзд', typeFull: 'Поселок разъезда' },
  { id: 667, type: 'сп', typeFull: 'Сельский поселок' },
  { id: 668, type: 'п. ст.', typeFull: 'Поселок при станции (поселок станции)' },
  { id: 1000, type: 'р-н', typeFull: 'Район' },
  { id: 1001, type: 'тер. СНТ', typeFull: 'Территория снт' },
  { id: 1002, type: 'тер. ДНТ', typeFull: 'Территория днт' },
  { id: 1003, type: 'снт', typeFull: 'Садовое товарищество' },
  { id: 1004, type: 'тер. ТСН', typeFull: 'Территория тсн' },
  { id: 1005, type: 'днп', typeFull: 'Дачное неком-е партнерство' },
  { id: 1006, type: 'тер. ДНП', typeFull: 'Территория днп' },
  { id: 1007, type: 'зона', typeFull: 'Зона (массив)' },
  { id: 1008, type: 'тер. ДПК', typeFull: 'Территория дпк' },
  { id: 1009, type: 'тер.СОСН', typeFull: 'Территория сосн' },
  { id: 1010, type: 'сад', typeFull: 'Сад' },
  { id: 1011, type: 'тер. СПК', typeFull: 'Территория спк' },
  { id: 1012, type: 'местность', typeFull: 'Местность' },
  { id: 1013, type: 'тер', typeFull: 'Территория' },
  { id: 1014, type: 'гск', typeFull: 'Гаражно-строительный кооп.' },
  { id: 1015, type: 'СПК', typeFull: 'СПК' },
  { id: 1016, type: 'остров', typeFull: 'Остров' },
  { id: 1017, type: 'тер. ОНО', typeFull: 'Территория оно' },
];

export const streetTypes = [
  { id: '701', type: 'аллея', typeFull: 'Аллея' },
  { id: '702', type: 'б-р', typeFull: 'Бульвар' },
  { id: '703', type: 'въезд', typeFull: 'Въезд' },
  { id: '704', type: 'дор', typeFull: 'Дорога' },
  { id: '705', type: 'жт', typeFull: 'Животноводческая точка' },
  { id: '706', type: 'заезд', typeFull: 'Заезд' },
  { id: '707', type: 'кв-л', typeFull: 'Квартал' },
  { id: '708', type: 'км', typeFull: 'Километр' },
  { id: '709', type: 'кольцо', typeFull: 'Кольцо' },
  { id: '710', type: 'линия', typeFull: 'Линия' },
  { id: '711', type: 'наб', typeFull: 'Набережная' },
  { id: '712', type: 'остров', typeFull: 'Остров' },
  { id: '713', type: 'парк', typeFull: 'Парк' },
  { id: '714', type: 'пер', typeFull: 'Переулок' },
  { id: '715', type: 'переезд', typeFull: 'Переезд' },
  { id: '716', type: 'пл', typeFull: 'Площадь' },
  { id: '717', type: 'пл-ка', typeFull: 'Площадка' },
  { id: '718', type: 'проезд', typeFull: 'Проезд' },
  { id: '719', type: 'пр-кт', typeFull: 'Проспект' },
  { id: '720', type: 'просек', typeFull: 'Просек' },
  { id: '721', type: 'проселок', typeFull: 'Проселок' },
  { id: '722', type: 'проулок', typeFull: 'Проулок' },
  { id: '723', type: 'сад', typeFull: 'Сад' },
  { id: '724', type: 'сквер', typeFull: 'Сквер' },
  { id: '725', type: 'стр', typeFull: 'Строение' },
  { id: '726', type: 'тер', typeFull: 'Территория' },
  { id: '727', type: 'тракт', typeFull: 'Тракт' },
  { id: '728', type: 'туп', typeFull: 'Тупик' },
  { id: '729', type: 'ул', typeFull: 'Улица' },
  { id: '730', type: 'уч-к', typeFull: 'Участок' },
  { id: '731', type: 'ш', typeFull: 'Шоссе' },
  { id: '732', type: 'пр-д', typeFull: 'Проезд' },
  { id: '733', type: 'пр-к', typeFull: 'Просек' },
  { id: '734', type: 'пр-ка', typeFull: 'Просека' },
  { id: '735', type: 'г-к', typeFull: 'Городок' },
  { id: '736', type: 'д', typeFull: 'Деревня' },
  { id: '738', type: 'ж/д_казарм', typeFull: 'Железнодорожная казарма' },
  { id: '742', type: 'ж/д_ст', typeFull: 'Железнодорожная станция' },
  { id: '743', type: 'казарма', typeFull: 'Казарма' },
  { id: '744', type: 'м', typeFull: 'Местечко' },
  { id: '745', type: 'мкр', typeFull: 'Микрорайон' },
  { id: '746', type: 'нп', typeFull: 'Населенный пункт' },
  { id: '747', type: 'платф', typeFull: 'Платформа' },
  { id: '748', type: 'п', typeFull: 'Поселок' },
  { id: '750', type: 'пл.р-н', typeFull: 'Планировочный район' },
  { id: '751', type: 'п/ст', typeFull: 'Поселок и(при) станция(и)' },
  { id: '753', type: 'пр-лок', typeFull: 'Проселок' },
  { id: '754', type: 'рзд', typeFull: 'Разъезд' },
  { id: '755', type: 'с', typeFull: 'Село' },
  { id: '756', type: 'сл', typeFull: 'Слобода' },
  { id: '757', type: 'ст', typeFull: 'Станция' },
  { id: '758', type: 'х', typeFull: 'Хутор' },
  { id: '759', type: 'ж/д_платф', typeFull: 'Железнодорожная платформа' },
  { id: '760', type: 'проул.', typeFull: 'Проулок' },
  { id: '761', type: 'спуск', typeFull: 'Спуск' },
  { id: '762', type: 'ул.', typeFull: 'Улица' },
  { id: '763', type: 'гск', typeFull: 'Гаражно-строительный кооп.' },
  { id: '764', type: 'снт', typeFull: 'Садовое неком-е товарищество' },
  { id: '765', type: 'ал.', typeFull: 'Аллея' },
  { id: '766', type: 'тер. ДНТ', typeFull: 'Территория ДНТ' },
  { id: '768', type: 'вал', typeFull: 'Вал' },
  { id: '769', type: 'ферма', typeFull: 'Ферма' },
  { id: '771', type: 'ряды', typeFull: 'Ряды' },
  { id: '774', type: 'просека', typeFull: 'Просека' },
  { id: '775', type: 'рзд.', typeFull: 'Разъезд' },
  { id: '777', type: 'зона', typeFull: 'Зона' },
  { id: '779', type: 'тер. СНТ', typeFull: 'Территория СНТ' },
  { id: '780', type: 'местность', typeFull: 'Местность' },
  { id: '782', type: 'с/т', typeFull: 'Садовое товарищество' },
  { id: '784', type: 'сзд.', typeFull: 'Съезд' },
  { id: '786', type: 'с-к', typeFull: 'Спуск' },
  { id: '787', type: 'днп', typeFull: 'Дачное неком-е партнерство' },
  { id: '788', type: 'н/п', typeFull: 'Некоммерческое партнерство' },
  { id: '789', type: 'ф/х', typeFull: 'Фермерское хозяйство' },
  { id: '790', type: 'промзона', typeFull: 'Промзона' },
  { id: '791', type: 'взв.', typeFull: 'Взвоз' },
  { id: '792', type: 'с-р', typeFull: 'Сквер' },
  { id: '793', type: 'ш.', typeFull: 'Шоссе' },
  { id: '794', type: 'ззд.', typeFull: 'Заезд' },
  { id: '795', type: 'к-цо', typeFull: 'Кольцо' },
  { id: '796', type: 'лн.', typeFull: 'Линия' },
  { id: '797', type: 'мгстр.', typeFull: 'Магистраль' },
  { id: '798', type: 'наб.', typeFull: 'Набережная' },
  { id: '799', type: 'пер.', typeFull: 'Переулок' },
  { id: '1000', type: 'ВЧ', typeFull: 'Войсковая часть' },
  { id: '1001', type: 'урочище', typeFull: 'Урочище' },
];

export const houseTypes = [
  { id: 1, type: 'д', typeFull: 'Дом' },
  { id: 2, type: 'двлд', typeFull: 'Домовладение' },
  { id: 3, type: 'влд', typeFull: 'Владение' },
  { id: 4, type: 'уч', typeFull: 'Участок' },
  { id: 5, type: 'зд', typeFull: 'Здание' },
  { id: 6, type: 'к', typeFull: 'Корпус' },
  { id: 7, type: 'стр', typeFull: 'Строение' },
  { id: 8, type: 'соор', typeFull: 'Сооружение' },
  { id: 9, type: 'в/ч', typeFull: 'Войсковая часть' },
  { id: 10, type: 'вч', typeFull: 'Воинская часть' },
];

export const buildingTypes = [
  { id: 1, type: 'стр', typeFull: 'Строение' },
  { id: 2, type: 'к', typeFull: 'Корпус' },
  { id: 3, type: 'литера', typeFull: 'Литера' },
  { id: 4, type: 'соор', typeFull: 'Сооружение' },
  { id: 5, type: 'сек', typeFull: 'Секция' },
];

export const apartmentTypes = [
  { id: 1, type: 'кв', typeFull: 'Квартира' },
  { id: 2, type: 'помещ', typeFull: 'Помещение' },
  { id: 3, type: 'ком', typeFull: 'Комната' },
  { id: 4, type: 'уч', typeFull: 'Участок' },
  { id: 5, type: 'офис', typeFull: 'Офис' },
  { id: 6, type: 'СЕК', typeFull: 'Секция' },
];
